<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { ConfiguratorViewer } from '@/components/configurator'

defineOptions({
  name: 'ViewerArea'
})

// Props
interface Props {
  viewMode?: 'exterior' | 'interior'
}

const props = withDefaults(defineProps<Props>(), {
  viewMode: 'exterior'
})

// État local pour le mode de vue
const currentViewMode = ref<'exterior' | 'interior'>(props.viewMode)

// Fonction pour gérer le changement de mode de vue
function handleViewModeChange(event: Event) {
  const customEvent = event as CustomEvent<{ mode: 'exterior' | 'interior' }>
  console.log('[ViewerArea] viewModeChange reçu:', customEvent.detail.mode)
  currentViewMode.value = customEvent.detail.mode
}

// Ajouter l'écouteur d'événement au montage
onMounted(() => {
  console.log('[ViewerArea] Montage du composant, ajout de l\'écouteur viewModeChange')
  window.addEventListener('viewModeChange', handleViewModeChange)
})

// Retirer l'écouteur avant la destruction
onBeforeUnmount(() => {
  console.log('[ViewerArea] Démontage du composant, retrait de l\'écouteur viewModeChange')
  window.removeEventListener('viewModeChange', handleViewModeChange)
})

// Émettre les événements du viewer
interface Emits {
  (e: 'angleChange', angle: number): void
  (e: 'loadProgress', progress: number): void
  (e: 'loadComplete'): void
}

const emit = defineEmits<Emits>()

// Handlers d'événements du viewer
function handleAngleChange(angle: number) {
  emit('angleChange', angle)
}

function handleLoadProgress(progress: number) {
  emit('loadProgress', progress)
}

function handleLoadComplete() {
  emit('loadComplete')
}
</script>

<template>
  <div class="viewer-area">
    <ConfiguratorViewer
      :view-mode="currentViewMode"
      @angle-change="handleAngleChange"
      @load-progress="handleLoadProgress"
      @load-complete="handleLoadComplete"
    />
  </div>
</template>

<style scoped>
.viewer-area {
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 875px;
  margin-inline: auto;
}

</style>